export default {
    methods: {
        completionClickHandler({ event, completion, position, source, customEventType }, callback) {
            switch (completion.label) {
            case 'offers':
                this.$emit('offer-click', {
                    ...completion,
                    source: 'productClickCompletions',
                    pos: position,
                    event,
                    customEventType,
                });
                break;
            case 'extraOffers':
                this.$emit('offer-click', {
                    ...completion,
                    source: 'productClickCompletions',
                    pos: position,
                    event,
                    customEventType,
                });
                break;
            case 'categories':
                this.$emit('category-click', {
                    ...completion,
                    source: this.$root.$refs.inner.typeWidget === 'image-search-similar' ? 'iwCategoryClick' : 'categoryClick',
                    pos: position,
                    event,
                    customEventType,
                });
                callback(completion);
                break;
            case 'special_offers':
                this.$emit('special-offers-click', {
                    ...completion,
                    source: 'specialOfferClick',
                    pos: position,
                    event,
                    customEventType,
                });
                callback(completion);
                break;
            case 'suggestions':
                this.$emit('suggestions-click', {
                    ...completion,
                    source: 'suggestionsClick',
                    pos: position,
                    event,
                    customEventType,
                });
                callback(completion);
                break;
            case 'popular':
                this.$emit('popular-click', {
                    ...completion,
                    source: 'popularClick',
                    pos: position,
                    event,
                    customEventType,
                });
                callback(completion);
                break;
            case 'brands':
                this.$emit('brand-click', {
                    ...completion,
                    source: 'brandClick',
                    pos: position,
                    event,
                    customEventType,
                });
                callback(completion);
                break;
            case 'history':
                this.$emit('history-click', {
                    ...completion,
                    source: 'historyClick',
                    pos: position,
                    event,
                    customEventType,
                });
                callback(completion);
                break;
            default:
                if (event.button === 2) return;
                callback(completion);
                break;
            }
        },
    },
};
